import { render, staticRenderFns } from "./LoaderWidget.vue?vue&type=template&id=cf2cbbc0&scoped=true"
import script from "./LoaderWidget.vue?vue&type=script&lang=js"
export * from "./LoaderWidget.vue?vue&type=script&lang=js"
import style0 from "./LoaderWidget.vue?vue&type=style&index=0&id=cf2cbbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2cbbc0",
  null
  
)

export default component.exports